import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { vuetifyComponents } from '@policyfly/components'
import { createVuetifyOptions } from '@policyfly/utils/plugin'
import { createVuetify } from 'vuetify'

const opts = createVuetifyOptions({
  extraComponents: vuetifyComponents(),
  useAppDefaults: true,
})
export const vuetify = createVuetify(opts)
